export const passwordMessage = ({store}) => store.passwordReducer.message;
export const passwordLoading = ({store}) => store.passwordReducer.loading;
export const passwordError = ({store}) => store.passwordReducer.message;

export const confirmPasswordMessage = ({store}) => store.passwordConfirmReducer.message;
export const confirmPasswordLoading = ({store}) => store.passwordConfirmReducer.loading;
export const confirmPasswordError = ({store}) => store.passwordConfirmReducer.error;
